<template lang="pug">
  #ImportarPedido
    Header

    div.ip-breadcrumb
      div.ip-breadcrumb-inner
        a.ip-bread-link(href='/') Inicio
        span.ip-bread-sep /
        span.ip-bread-cur Importar pedido desde Excel

    div.ip-page
      div.ip-container

        //- Header
        div.ip-header
          div.ip-title-wrap
            v-icon.ip-title-icon(color='#0F4DFF' size='28') mdi-file-import
            span.ip-title Importar pedido
          div.ip-mode-tabs
            div.ip-mode-tab(:class="{ active: modoImport === 'excel' }" @click="modoImport = 'excel'; step = 1")
              v-icon(small left) mdi-file-excel
              | Desde Excel
            div.ip-mode-tab(:class="{ active: modoImport === 'texto' }" @click="modoImport = 'texto'; step = 5")
              v-icon(small left) mdi-text-box-outline
              | Desde texto

        //- Paso 1: Subir archivo
        div.ip-step(v-if='step === 1')
          div.ip-drop-zone(
            @click='$refs.fileInput.click()'
            @dragover.prevent
            @drop.prevent='onDrop'
            :class="{ 'ip-drop-active': dragging }"
            @dragenter='dragging=true'
            @dragleave='dragging=false'
          )
            v-icon(size='56' color='#0F4DFF') mdi-cloud-upload-outline
            span.ip-drop-title Arrastra tu archivo Excel aquí
            span.ip-drop-sub o haz clic para seleccionar (.xlsx)
            input(ref='fileInput' type='file' accept='.xlsx' style='display:none' @change='onFileChange')
          div.ip-or-row
            span ó
          div.ip-url-row
            v-text-field(v-model='urlInput' label='URL del archivo Excel o Google Sheets' dense outlined hide-details placeholder='https://...' style='flex:1;')
            v-btn(depressed color='#0F4DFF' dark @click='cargarDesdeUrl' :loading='loadingUrl' style='margin-left:12px;text-transform:none;border-radius:8px;')
              v-icon(left small) mdi-link
              | Cargar URL

        //- Paso 2: Mapear columnas
        div.ip-step(v-if='step === 2')
          div.ip-map-title Mapea las columnas del archivo
          div.ip-map-preview
            span.ip-map-label Columnas detectadas:
            v-chip(v-for='(h, i) in headers' :key='i' small outlined style='margin:2px;') {{h || '(vacía)'}}
          div.ip-map-grid
            div.ip-map-item
              div.ip-map-field Columna de Código de Producto
              v-select(v-model='mapCode' :items='headerItems' dense outlined hide-details label='Seleccionar columna')
            div.ip-map-item
              div.ip-map-field Columna de Cantidad
              v-select(v-model='mapQty' :items='headerItems' dense outlined hide-details label='Seleccionar columna')
          div.ip-map-preview(v-if='previewRows.length > 0')
            span.ip-map-label Vista previa (primeras 3 filas):
            table.ip-preview-table
              thead
                tr
                  th(v-for='(h,i) in headers' :key='i') {{h || i}}
              tbody
                tr(v-for='(row, ri) in previewRows' :key='ri')
                  td(v-for='(cell, ci) in row' :key='ci') {{cell}}
          div.ip-map-actions
            v-btn(depressed @click='step=1' style='text-transform:none;border-radius:8px;margin-right:8px;')
              v-icon(left small) mdi-arrow-left
              | Volver
            v-btn(depressed color='#0F4DFF' dark @click='procesarExcel' :disabled='mapCode === null || mapQty === null' style='text-transform:none;border-radius:8px;')
              v-icon(left small) mdi-cog-play
              | Procesar

        //- Paso 5: Importar desde texto
        div.ip-step(v-if='step === 5')
          div.ip-text-title
            v-icon(left color='#0F4DFF') mdi-text-box-outline
            span Pega los productos a importar
          div.ip-text-hint
            | Un producto por línea. Formato:
            code código cantidad
            |  ó
            code cantidad código
            | . Separador: espacio, coma, tab o punto y coma.
            br
            | Ejemplo:
            br
            code ART001 5
            br
            code 10 ART002
            br
            code ART003,3
          v-textarea(
            v-model='textoImport'
            outlined
            dense
            hide-details
            rows='12'
            placeholder='ART001 5\nART002 10\nART003,3'
            style='font-family:monospace;margin-top:16px;'
          )
          div.ip-map-actions
            v-btn(depressed @click='textoImport=""' style='text-transform:none;border-radius:8px;margin-right:8px;')
              v-icon(left small) mdi-delete-outline
              | Limpiar
            v-btn(depressed color='#0F4DFF' dark @click='procesarTexto' :disabled='!textoImport.trim()' style='text-transform:none;border-radius:8px;')
              v-icon(left small) mdi-cog-play
              | Procesar

        //- Paso 3: Procesando
        div.ip-step.ip-step-center(v-if='step === 3')
          v-progress-circular(indeterminate color='#0F4DFF' size='64')
          span.ip-proc-text Buscando productos en el catálogo...
          v-progress-linear(:value='progreso' color='#0F4DFF' rounded height='8' style='width:320px;margin-top:16px;')
          span.ip-proc-sub {{progresoTexto}}

        //- Paso 4: Resumen + carritos
        div.ip-step(v-if='step === 4')
          div.ip-summary-header
            v-icon(color='#38a169' size='32') mdi-check-circle
            span.ip-summary-title Importación completada

          //- Stats
          div.ip-stats-grid
            div.ip-stat-card.ok
              v-icon(color='#38a169') mdi-check
              div.ip-stat-num {{importados.length}}
              div.ip-stat-lbl Importados
            div.ip-stat-card.nf
              v-icon(color='#e53e3e') mdi-magnify-close
              div.ip-stat-num {{noEncontrados.length}}
              div.ip-stat-lbl No encontrados
            div.ip-stat-card.stock
              v-icon(color='#9f7aea') mdi-package-variant-closed-remove
              div.ip-stat-num {{sinStock.length}}
              div.ip-stat-lbl Sin stock
            div.ip-stat-card.policy
              v-icon(color='#ed8936') mdi-gavel
              div.ip-stat-num {{politica.length}}
              div.ip-stat-lbl Política

          //- Carritos generados
          div.ip-carritos-title
            v-icon(left color='#0F4DFF') mdi-cart-arrow-down
            span {{carritos.length}} carrito(s) generado(s) (máx. 25 ítems c/u)
            v-btn(small depressed color='#0F4DFF' dark @click='guardarTodosEnStore' :disabled='todosGuardados' style='text-transform:none;border-radius:8px;margin-left:auto;')
              v-icon(left small) mdi-cart-arrow-down
              | {{ todosGuardados ? 'Guardados ✓' : 'Guardar todos en mis carritos' }}

          div.ip-carrito-card(v-for='(cart, ci) in carritos' :key='ci' :class="{ 'ip-carrito-saved': cartAdded[ci] }")
            div.ip-carrito-head
              v-icon(color='#0F4DFF' small) mdi-cart
              span Carrito {{ci + 1}} — {{cart.length}} ítem(s)
              span.ip-carrito-total Total: ${{calcTotal(cart)}}
              v-chip(v-if='cartAdded[ci]' small color='#38a169' dark style='margin-left:auto;')
                v-icon(left x-small) mdi-check
                | Guardado
            div.ip-carrito-items
              div.ip-carrito-row(v-for='(item, ii) in cart' :key='ii')
                span.ip-ci-name {{item.art_des}}
                span.ip-ci-code {{item.co_art.trim()}}
                span.ip-ci-qty x{{item.cant}}
                span.ip-ci-price ${{(item.precio * item.cant).toFixed(2)}}

          //- Problemas
          div.ip-problems(v-if='noEncontrados.length || sinStock.length || politica.length')
            div.ip-prob-section(v-if='noEncontrados.length')
              div.ip-prob-title
                v-icon(color='#e53e3e' small) mdi-magnify-close
                span No encontrados ({{noEncontrados.length}})
              div.ip-prob-row(v-for='p in noEncontrados' :key='p.code')
                span.ip-prob-code {{p.code}}
                span.ip-prob-reason No existe en el catálogo
            div.ip-prob-section(v-if='sinStock.length')
              div.ip-prob-title
                v-icon(color='#9f7aea' small) mdi-package-variant-closed-remove
                span Sin stock ({{sinStock.length}})
              div.ip-prob-row(v-for='p in sinStock' :key='p.code')
                span.ip-prob-code {{p.code}}
                span.ip-prob-name {{p.name}}
                span.ip-prob-reason {{p.reason}}
            div.ip-prob-section(v-if='politica.length')
              div.ip-prob-title
                v-icon(color='#ed8936' small) mdi-gavel
                span Política de venta ({{politica.length}})
              div.ip-prob-row(v-for='p in politica' :key='p.code')
                span.ip-prob-code {{p.code}}
                span.ip-prob-name {{p.name}}
                span.ip-prob-reason {{p.reason}}

          div.ip-actions-final
            v-btn(depressed @click='resetear' style='text-transform:none;border-radius:8px;margin-right:8px;')
              v-icon(left small) mdi-refresh
              | Nueva importación
            v-btn(depressed color='#38a169' dark @click='$router.push("/carrito")' :disabled='!todosGuardados' style='text-transform:none;border-radius:8px;')
              v-icon(left small) mdi-cart-arrow-right
              | Ver mis carritos ({{carritos.length}})

    Footer
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Api from '@/services/methods'
import * as XLSX from 'xlsx'
import { mapState } from 'vuex'
import { EventBus } from '../Events.js'

export default {
  name: 'ImportarPedido',
  components: { Header, Footer },
  data () {
    return {
      step: 1,
      modoImport: 'excel',
      textoImport: '',
      dragging: false,
      urlInput: '',
      loadingUrl: false,
      workbook: null,
      headers: [],
      previewRows: [],
      mapCode: null,
      mapQty: null,
      progreso: 0,
      progresoTexto: '',
      importados: [],
      noEncontrados: [],
      sinStock: [],
      politica: [],
      carritos: [],
      cartAdded: {}
    }
  },
  computed: {
    ...mapState(['fercoWeb', 'carFerco']),
    headerItems () {
      return this.headers.map((h, i) => ({ text: h || `Columna ${i + 1}`, value: i }))
    },
    todosGuardados () {
      return this.carritos.length > 0 && Object.keys(this.cartAdded).length === this.carritos.length
    }
  },
  methods: {
    onDrop (e) {
      this.dragging = false
      const file = e.dataTransfer.files[0]
      if (file) this.leerArchivo(file)
    },
    onFileChange (e) {
      const file = e.target.files[0]
      if (file) this.leerArchivo(file)
    },
    async cargarDesdeUrl () {
      if (!this.urlInput.trim()) return
      this.loadingUrl = true
      try {
        let url = this.urlInput.trim()
        if (url.includes('docs.google.com/spreadsheets')) {
          const match = url.match(/\/spreadsheets\/d\/([a-zA-Z0-9-_]+)/)
          if (match) url = `https://docs.google.com/spreadsheets/d/${match[1]}/export?format=xlsx`
        }
        const res = await fetch(url)
        if (!res.ok) throw new Error('No se pudo descargar el archivo')
        const buffer = await res.arrayBuffer()
        this.parsearBuffer(new Uint8Array(buffer))
      } catch (e) {
        this.$swal.fire('Error', e.message, 'error')
      } finally {
        this.loadingUrl = false
      }
    },
    leerArchivo (file) {
      const reader = new FileReader()
      reader.onload = (e) => this.parsearBuffer(new Uint8Array(e.target.result))
      reader.readAsArrayBuffer(file)
    },
    parsearBuffer (data) {
      const wb = XLSX.read(data, { type: 'array' })
      const sheetName = wb.SheetNames[0]
      const sheet = wb.Sheets[sheetName]
      const rows = XLSX.utils.sheet_to_json(sheet, { header: 1 })
      if (!rows || rows.length < 2) {
        this.$swal.fire('Error', 'El archivo debe tener al menos una fila de encabezado y una de datos', 'error')
        return
      }
      this.workbook = rows
      this.headers = rows[0].map(h => h ? h.toString() : '')
      this.previewRows = rows.slice(1, 4).map(r => this.headers.map((_, i) => r[i] !== undefined ? r[i].toString() : ''))
      // Auto-detectar columnas por nombre
      this.mapCode = null
      this.mapQty = null
      this.headers.forEach((h, i) => {
        const hl = h.toLowerCase()
        if (!this.mapCode && (hl.includes('cod') || hl.includes('art') || hl.includes('ref') || hl === 'código' || hl === 'codigo')) this.mapCode = i
        if (!this.mapQty && (hl.includes('cant') || hl.includes('qty') || hl.includes('quantity') || hl === 'cantidad')) this.mapQty = i
      })
      this.step = 2
    },
    async procesarExcel () {
      this.step = 3
      this.progreso = 0
      this.importados = []
      this.noEncontrados = []
      this.sinStock = []
      this.politica = []
      this.carritos = []
      this.cartAdded = {}

      const rows = this.workbook.slice(1).filter(r => r && r.length > 0)
      const codeIdx = this.mapCode
      const qtyIdx = this.mapQty

      // Parsear filas
      const lineas = []
      for (const row of rows) {
        const rawCode = row[codeIdx] !== undefined ? row[codeIdx].toString().trim() : ''
        const rawQty = row[qtyIdx] !== undefined ? row[qtyIdx].toString().trim() : ''
        if (!rawCode || !rawQty) continue
        // normalizar código numérico
        const coArt = !isNaN(parseFloat(rawCode)) && !rawCode.includes(' ') ? parseInt(parseFloat(rawCode)).toString() : rawCode
        const cant = parseInt(parseFloat(rawQty))
        if (!coArt || isNaN(cant) || cant <= 0) continue
        lineas.push({ coArt, cant })
      }

      if (lineas.length === 0) {
        this.$swal.fire('Sin datos', 'No se encontraron filas válidas en el archivo.', 'warning')
        this.step = 2
        return
      }

      // Buscar productos en bulk (en lotes de 50)
      this.progresoTexto = `Consultando ${lineas.length} productos...`
      const LOTE = 50
      const productosMap = {}
      const coPrecio = this.fercoWeb && this.fercoWeb.co_precio ? this.fercoWeb.co_precio : null

      for (let i = 0; i < lineas.length; i += LOTE) {
        const lote = lineas.slice(i, i + LOTE)
        try {
          const res = await Api.post('web/productos-bulk', {
            codigos: lote.map(l => l.coArt),
            co_precio: coPrecio
          })
          if (res.data && Array.isArray(res.data)) {
            res.data.forEach(p => {
              productosMap[p.co_art.trim()] = p
            })
          }
        } catch (e) {
          console.error('Error buscando productos:', e)
        }
        this.progreso = Math.round(((i + LOTE) / lineas.length) * 60)
      }

      // Procesar cada línea con validaciones
      const itemsValidos = []
      for (let idx = 0; idx < lineas.length; idx++) {
        const { coArt, cant } = lineas[idx]
        this.progresoTexto = `Validando ${idx + 1} / ${lineas.length}`
        this.progreso = 60 + Math.round((idx / lineas.length) * 40)

        // Buscar producto en mapa (búsqueda flexible)
        let producto = productosMap[coArt]
        if (!producto) {
          // buscar con padding de espacios
          const found = Object.values(productosMap).find(p => p.co_art.trim() === coArt)
          if (found) producto = found
        }

        if (!producto) {
          this.noEncontrados.push({ code: coArt })
          continue
        }

        // Calcular equivalente
        let equivalente = 1
        if (producto.equivalencia && Array.isArray(producto.equivalencia) && producto.equivalencia.length > 1) {
          equivalente = producto.equivalencia[1] || 1
        }

        // Validar stock
        const stockUnidades = (producto.stock || 0) * equivalente
        if (stockUnidades <= 0) {
          this.sinStock.push({ code: coArt, name: producto.art_des, reason: 'Sin stock disponible' })
          continue
        }
        if (cant > stockUnidades) {
          this.sinStock.push({ code: coArt, name: producto.art_des, reason: `Stock disponible: ${Math.floor(stockUnidades)}` })
          continue
        }

        // Validar política de venta (múltiplo de equivalente)
        if (equivalente > 1 && cant % equivalente !== 0) {
          this.politica.push({ code: coArt, name: producto.art_des, reason: `La cantidad debe ser múltiplo de ${equivalente}` })
          continue
        }

        // Determinar precio
        let precio = 0
        if (producto.precio !== undefined) {
          precio = producto.precio
        } else if (producto.precios && producto.precios.length > 0) {
          const pp = coPrecio ? producto.precios.find(p => p.co_precio && p.co_precio.trim() === coPrecio.trim()) : null
          precio = pp ? pp.monto : producto.precios[0].monto
        }

        itemsValidos.push({
          _id: producto._id,
          co_art: producto.co_art,
          art_des: producto.art_des,
          cant,
          precio,
          stock: producto.stock || 0,
          equivalente,
          iva: producto.iva || 0,
          unidad: producto.unidades && producto.unidades.length > 0 ? producto.unidades[0] : 'UNID',
          modelo: producto.modelo,
          campo8: producto.campo8,
          tipo_imp: producto.tipo_imp || ''
        })
        this.importados.push({ code: coArt, name: producto.art_des, quantity: cant })
      }

      // Dividir en carritos de 25
      // Agrupar ítems con mismo co_art (puede venir repetido en el Excel)
      const agrupados = []
      itemsValidos.forEach(item => {
        const existing = agrupados.find(a => a.co_art.trim() === item.co_art.trim())
        if (existing) {
          existing.cant += item.cant
        } else {
          agrupados.push({ ...item })
        }
      })

      for (let i = 0; i < agrupados.length; i += 25) {
        this.carritos.push(agrupados.slice(i, i + 25))
      }

      this.progreso = 100
      this.step = 4
    },
    calcTotal (cart) {
      return cart.reduce((sum, i) => sum + (i.precio * i.cant), 0).toFixed(2)
    },
    async procesarTexto () {
      const lineas = this.textoImport.split('\n').filter(l => l.trim())
      if (!lineas.length) return

      this.step = 3
      this.progreso = 0
      this.progresoTexto = 'Parseando líneas...'
      this.importados = []
      this.noEncontrados = []
      this.sinStock = []
      this.politica = []
      this.carritos = []
      this.cartAdded = {}

      const parsed = []
      for (const line of lineas) {
        const parts = line.trim().split(/[^a-zA-Z0-9.-]+/).filter(p => p)
        if (parts.length !== 2) {
          this.politica.push({ code: line.trim(), name: 'Línea inválida', reason: 'No contiene código y cantidad claros' })
          continue
        }
        const [p1, p2] = parts
        const n1 = Number(p1); const n2 = Number(p2)
        const p1Num = !isNaN(n1) && Number.isInteger(n1)
        const p2Num = !isNaN(n2) && Number.isInteger(n2)
        let coArt, cantidad
        if (!p1Num && p2Num) { coArt = p1; cantidad = n2 } else if (p1Num && !p2Num) { coArt = p2; cantidad = n1 } else if (p1Num && p2Num) {
          if (p1.length > p2.length) { coArt = p1; cantidad = n2 } else { coArt = p2; cantidad = n1 }
        } else {
          this.politica.push({ code: line.trim(), name: 'Línea inválida', reason: 'No se pudo identificar cantidad numérica' })
          continue
        }
        if (cantidad <= 0) {
          this.politica.push({ code: coArt, name: '', reason: 'Cantidad debe ser mayor a 0' })
          continue
        }
        parsed.push({ coArt: coArt.trim(), cantidad })
      }

      if (!parsed.length) {
        this.step = 4
        return
      }

      // Buscar en bulk
      this.progresoTexto = `Consultando ${parsed.length} productos...`
      const LOTE = 50
      const productosMap = {}
      const coPrecio = this.fercoWeb && this.fercoWeb.co_precio ? this.fercoWeb.co_precio : null
      for (let i = 0; i < parsed.length; i += LOTE) {
        const lote = parsed.slice(i, i + LOTE)
        try {
          const res = await Api.post('web/productos-bulk', { codigos: lote.map(l => l.coArt), co_precio: coPrecio })
          if (res.data && Array.isArray(res.data)) {
            res.data.forEach(p => { productosMap[p.co_art.trim().toUpperCase()] = p })
          }
        } catch (e) { console.error(e) }
        this.progreso = Math.round(((i + LOTE) / parsed.length) * 60)
      }

      this.progresoTexto = 'Validando stock y política...'
      const agrupados = {}
      for (const { coArt, cantidad } of parsed) {
        const prod = productosMap[coArt.toUpperCase()]
        if (!prod) { this.noEncontrados.push({ code: coArt }); continue }
        const equi = parseFloat(prod.equivalencia && prod.equivalencia[1] ? prod.equivalencia[1] : prod.equivalencia && prod.equivalencia[0] ? prod.equivalencia[0] : 1) || 1
        if (equi > 1 && cantidad % equi !== 0) {
          this.politica.push({ code: coArt, name: prod.art_des, reason: `Cantidad debe ser múltiplo de ${equi}` }); continue
        }
        const stockUnid = Math.trunc((prod.stock || 0) * equi)
        if (cantidad > stockUnid) {
          this.sinStock.push({ code: coArt, name: prod.art_des, pedido: cantidad, disponible: stockUnid }); continue
        }
        const key = prod._id.toString()
        if (agrupados[key]) agrupados[key].cant += cantidad
        else agrupados[key] = { ...prod, cant: cantidad, equivalente: equi }
      }

      const lista = Object.values(agrupados)
      this.importados = lista.map(p => ({ code: p.co_art, name: p.art_des, quantity: p.cant }))
      this.carritos = []
      for (let i = 0; i < lista.length; i += 25) this.carritos.push(lista.slice(i, i + 25))

      this.progreso = 100
      this.step = 4
    },
    guardarTodosEnStore () {
      this.$store.dispatch('setCarritosExtra', this.carritos)
      const added = {}
      this.carritos.forEach((_, ci) => { added[ci] = true })
      this.cartAdded = added
      EventBus.$emit('actCarrito')
      this.$swal.fire({
        icon: 'success',
        title: `${this.carritos.length} carrito(s) guardado(s)`,
        text: 'Puedes verlos y procesarlos en la página de Carrito',
        timer: 2500,
        showConfirmButton: false
      })
    },
    resetear () {
      this.step = 1
      this.workbook = null
      this.headers = []
      this.previewRows = []
      this.mapCode = null
      this.mapQty = null
      this.progreso = 0
      this.progresoTexto = ''
      this.importados = []
      this.noEncontrados = []
      this.sinStock = []
      this.politica = []
      this.carritos = []
      this.cartAdded = {}
      this.urlInput = ''
      this.textoImport = ''
      this.modoImport = 'excel'
      if (this.$refs.fileInput) this.$refs.fileInput.value = ''
    }
  }
}
</script>

<style lang="scss">
#ImportarPedido {
  background: #f7f9fc;
  min-height: 100vh;

  .ip-breadcrumb {
    background: white;
    border-bottom: 1px solid #eef0f4;
    padding: 10px 0;
    .ip-breadcrumb-inner {
      max-width: 900px;
      margin: 0 auto;
      padding: 0 24px;
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 13px;
    }
    .ip-bread-link { color: #0F4DFF; text-decoration: none; &:hover { text-decoration: underline; } }
    .ip-bread-sep { color: #a0aec0; }
    .ip-bread-cur { color: #4a5568; font-weight: 600; }
  }

  .ip-page { padding: 32px 16px 64px; }
  .ip-container { max-width: 900px; margin: 0 auto; }

  .ip-header {
    margin-bottom: 28px;
    .ip-title-wrap { display: flex; align-items: center; gap: 10px; margin-bottom: 12px; }
    .ip-title { font-size: 22px; font-weight: 800; color: #1a202c; }
    .ip-mode-tabs {
      display: flex;
      gap: 8px;
      .ip-mode-tab {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 8px 18px;
        border-radius: 8px;
        border: 2px solid #e2e8f0;
        font-size: 14px;
        font-weight: 600;
        color: #718096;
        cursor: pointer;
        transition: all 0.2s;
        &:hover { border-color: #0F4DFF; color: #0F4DFF; }
        &.active { border-color: #0F4DFF; background: #eef2ff; color: #0F4DFF; }
      }
    }
  }
  .ip-text-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 700;
    color: #1a202c;
    margin-bottom: 12px;
  }
  .ip-text-hint {
    background: #f7fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 12px 16px;
    font-size: 13px;
    color: #4a5568;
    line-height: 1.8;
    code {
      background: #edf2f7;
      border-radius: 4px;
      padding: 1px 6px;
      font-family: monospace;
      color: #0F4DFF;
    }
  }

  .ip-step {
    background: white;
    border-radius: 16px;
    padding: 32px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.06);
    &.ip-step-center {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      padding: 60px 32px;
    }
  }

  .ip-drop-zone {
    border: 2px dashed #c3d4ff;
    border-radius: 12px;
    padding: 48px 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    transition: all 0.2s;
    background: #f8faff;
    &:hover, &.ip-drop-active { border-color: #0F4DFF; background: #eef2ff; }
    .ip-drop-title { font-size: 16px; font-weight: 700; color: #2d3748; }
    .ip-drop-sub { font-size: 13px; color: #a0aec0; }
  }

  .ip-or-row { text-align: center; margin: 16px 0; color: #a0aec0; font-size: 13px; }
  .ip-url-row { display: flex; align-items: flex-start; gap: 0; }

  .ip-map-title { font-size: 16px; font-weight: 700; color: #1a202c; margin-bottom: 16px; }
  .ip-map-label { font-size: 12px; color: #718096; display: block; margin-bottom: 6px; }
  .ip-map-preview { margin-bottom: 20px; }
  .ip-map-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-bottom: 24px;
    @media (max-width: 600px) { grid-template-columns: 1fr; }
  }
  .ip-map-field { font-size: 13px; font-weight: 600; color: #4a5568; margin-bottom: 8px; }
  .ip-map-actions { display: flex; justify-content: flex-end; margin-top: 8px; }

  .ip-preview-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
    th, td { border: 1px solid #eef0f4; padding: 6px 10px; text-align: left; }
    th { background: #f1f4f9; font-weight: 700; color: #718096; }
  }

  .ip-proc-text { font-size: 16px; font-weight: 700; color: #2d3748; }
  .ip-proc-sub { font-size: 13px; color: #718096; }

  .ip-summary-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 24px;
    .ip-summary-title { font-size: 20px; font-weight: 800; color: #1a202c; }
  }

  .ip-stats-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
    margin-bottom: 28px;
    @media (max-width: 600px) { grid-template-columns: repeat(2, 1fr); }
  }
  .ip-stat-card {
    border-radius: 12px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    &.ok { background: #f0fff4; }
    &.nf { background: #fff5f5; }
    &.stock { background: #faf5ff; }
    &.policy { background: #fffaf0; }
    .ip-stat-num { font-size: 24px; font-weight: 800; color: #1a202c; }
    .ip-stat-lbl { font-size: 11px; color: #718096; font-weight: 600; text-transform: uppercase; }
  }

  .ip-carritos-title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 15px;
    font-weight: 700;
    color: #2d3748;
    margin-bottom: 16px;
  }

  .ip-carrito-card {
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 16px;
  }
  .ip-carrito-head {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #f8faff;
    padding: 12px 16px;
    border-bottom: 1px solid #e2e8f0;
    font-size: 14px;
    font-weight: 700;
    color: #2d3748;
    .ip-carrito-total { color: #0F4DFF; margin-left: 8px; }
  }
  .ip-carrito-items { padding: 8px 0; }
  .ip-carrito-row {
    display: grid;
    grid-template-columns: 1fr 120px 60px 80px;
    align-items: center;
    padding: 8px 16px;
    font-size: 13px;
    border-bottom: 1px solid #f7f9fc;
    &:last-child { border-bottom: none; }
    .ip-ci-name { color: #2d3748; font-weight: 500; }
    .ip-ci-code { color: #a0aec0; font-size: 11px; }
    .ip-ci-qty { color: #4a5568; font-weight: 600; text-align: center; }
    .ip-ci-price { color: #0F4DFF; font-weight: 700; text-align: right; }
  }

  .ip-problems { margin-top: 24px; }
  .ip-prob-section { margin-bottom: 16px; }
  .ip-prob-title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    font-weight: 700;
    margin-bottom: 8px;
  }
  .ip-prob-row {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 12px;
    background: #f7f9fc;
    border-radius: 6px;
    margin-bottom: 4px;
    font-size: 12px;
    .ip-prob-code { font-weight: 700; color: #2d3748; min-width: 80px; }
    .ip-prob-name { color: #4a5568; flex: 1; }
    .ip-prob-reason { color: #e53e3e; font-style: italic; }
  }

  .ip-actions-final {
    display: flex;
    justify-content: flex-end;
    margin-top: 24px;
    gap: 8px;
  }
}
</style>
